<div class="route-component">
    <wizard-control (onFinished)="finished()">

        <wizard-step title="Select Worksheets" [valid]="isWorkSheetSelectionValid()" [wizardStepInstance]="sheetSelectionComponent">
            <sales-sheet-selection #sheetSelectionComponent />
        </wizard-step>

        <wizard-step title="Select Rows" [valid]="isRowSelectionValid()" [wizardStepInstance]="rowSelectionComponent">
            <sales-range-selection #rowSelectionComponent />
        </wizard-step>

        <wizard-step title="Map Columns" [valid]="isColumnSelectionValid()" [wizardStepInstance]="columnSelectionComponent">
            <sales-column-selection #columnSelectionComponent />
        </wizard-step>

        <wizard-step title="Import" [valid]="isImportValid()" [wizardStepInstance]="importComponent">
            <sales-import-data #importComponent />
        </wizard-step>

        <wizard-step title="Summary">
            <h4>
                Done!
            </h4>
            <p>
                Batch imported succesfully, click Finish to mark as Complete
            </p>
        </wizard-step>

    </wizard-control>
</div>